import React from "react";
import {PostCard} from "./components/PostCard";
import {Post, TreeNode} from "../../types/Post";
import {timestampToDate} from '../../utils/date';
import {buildBreadcrumbFromTree} from "../../utils/category";
import {Typography} from "../../designSystem/components/Typography";

interface PostListProps {
  posts: Post[];
  categories: TreeNode[];
  onClickPost: (p: Post) => void;
}

export const PostList = ({
  posts,
  onClickPost,
  categories
}: PostListProps) => {
  if (!posts.length)
    return (
      <Typography variant="captionMuted">
        此分類目前沒有文章
      </Typography>
    );

  return (
    <div className="pt-3 px-3 py-3 space-y-3">
      {posts.map((post) => {
        const breadcrumb = buildBreadcrumbFromTree(categories, post.detailCategoryId) || [];
        const date = new Date(timestampToDate(post.createdAt));
        const dateString = `${date.getFullYear()}年${String(date.getMonth() + 1)}月${String(date.getDate())}日`
        return (
          <PostCard
            key={post.id}
            onClick={() => onClickPost(post)}
            title={post.title}
            category={breadcrumb[breadcrumb.length - 1]?.name}
            division={dateString}
            coverImage={post.coverImageUrl}
          />
        )
      })}
    </div>
  );
};